import { Component } from '@angular/core';
import { LoginComponent } from '../../../../components/public-user-component/auth/login-component/login-component';

@Component({
  selector: 'app-login',
  imports: [LoginComponent],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {}
